import React from 'react';
import { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const EmailVerifyMid = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const link = document.createElement('link');
      link.href = './assets/plugins/global/plugins.bundle.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }, 100);
    return () => clearTimeout(timer);

  }, [location.pathname]);
  
  const authData = localStorage.getItem('auth');
  const verifyEmail = authData ? JSON.parse(authData).email_verified_at : null;

  if (verifyEmail !== null && location.pathname === '/email/verify') {
    return <Navigate to="/" />;
  }

  if (verifyEmail === null && location.pathname !== '/email/verify') {
    return <Navigate to="/email/verify" replace />;
  }
  return <>{children}</>;
};

export default EmailVerifyMid;
